// Generic Drop-Down-List model by default expects 'text' and 'id' properties, instead of the conventional 'text' and 'value' properties. 
// The default behavior can be overridden via the options hash.
// Optionally supply a parent-collection to filter the drop-down-list.
var _ = require('underscore');
var $ = require('jquery');
var Backbone = require('backbone');
var Marionette = require('marionette');

var appendToolTip = function (selector) {
    selector.parent().find("div.tooltip-div").remove();
    var tooltipTitle = selector.attr("data-tooltip-title");
    var sanitizedTooltipTitle = encodeHTML(tooltipTitle);
    var $div = document.createElement("div");
    $div.className = "tooltip-div";
    var $span = document.createElement("span");
    $span.className = "tooltip-text-css";
    $span.innerText = sanitizedTooltipTitle;
    $div.append($span);
    selector.parent().append($div);
    selector.parent().addClass("tooltip-css");
};

var encodeHTML = function(text) {
    return text.replace(/[&<>"'/]/g, function (char) {
        return {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            '/': '&#x2F;'
        }[char];
    });
}

// Drop-down-list item-view. Expects that the template contains a 'select' element.        
var View = Marionette.View.extend({
    collectionEvents: {
        'sync reset': 'render'
    },
    events: {
        'change @ui.select': 'dropdownChanged'
    },
    template: '#dropdownTemplate',
    ui: {
        select: '#select',
        print: "#print"
    },
    initialize: function () {
        if (this.options.parentCollection || this.options.childCollection) {
            this.options.filterByAttribute = this.options.filterByAttribute || 'parentId';
            this.parentFilterByAttribute = this.options.parentFilterByAttribute || 'id';// Let's give consumers ability to pick another parent-model attribute to filter on, if needs be.
            this.collectionClone = this.collection.clone();// Create a local copy of our collection so that we don't have to fecth it again from the source, whereever that may be i.e. bootstraped or the server!
            if (this.options.parentCollection) {
                this.listenTo(this.options.parentCollection, 'change', this.parentChanged);// let's listen to changes on the parent so we can bubble those up...
                this.parentChanged(this.options.parentCollection.findWhere({ selected: true }) || new Backbone.Model());// Initialize...
            }
            if (this.options.childCollection) {
                this.listenTo(this.options.childCollection, 'change', this.childChanged);
            }
        }// Ascertain if this view needs to be filtered via a parent or child collection.
    },
    onRender: function () {
        var labels = EY.Consultation.Labels;
        var collection = this.collection;
        var autoselect = this.options.autoselect;
        var placeholder = _.result(this.options, "placeholder") || labels.Select; // This can be changed to accept conventional 'text' and 'value' properties.
        var readonly = this.options.readonly;
        var resourceKeyAffix = this.options.resourceKeyAffix || '';
        var resourceKeyAttribute = this.options.resourceKeyAttribute;
        var selectionAttribute = this.options.selectionAttribute || 'id';
        var selectedInCollection = this.collection.findWhere({ selected: true });
        var selection = selectedInCollection ? selectedInCollection.get(selectionAttribute) : (this.options.selection || -1);
        var textAttribute = this.options.textAttribute || 'text';
        var valueAttribute = this.options.valueAttribute || 'id';
        var $select = this.ui.select;

        $select.append($(new Option(placeholder, -1, true, true)).attr('disabled', 'disabled')); // If a default value/placeholder is supplied lets insert it at the beginning.
        collection.each(function (model) {
            var selected = (selection == model.get(selectionAttribute) || (autoselect && collection.length === 1) ? true : false);
            $select.append(new Option(resourceKeyAttribute ? labels[resourceKeyAffix + model.get(resourceKeyAttribute)] : model.get(textAttribute), model.get(valueAttribute), selected, selected));
        }); // Append the models in our collection as options.

        if (readonly) {
            $select.attr('disabled', 'disabled');
        } // Make the control readonly.

        this.selectionChanged(); // Fire a selection-changed to set things in motion for dependent consumers...
    },
    parentChanged: function (parent) {
        var filterByAttribute = this.options.filterByAttribute;
        var parentFilterByAttribute = this.parentFilterByAttribute;
        var filter = this.collectionClone.filter(function (child) {
            return child.get(filterByAttribute) == parent.get(parentFilterByAttribute);
        }); // Reset the bound collection by filtering out based on parent/child filter-attributes from the options-hash.

        this.reset(filter);
    },
    childChanged: function (child) {
        var filterByAttribute = this.options.filterByAttribute;
        var parent = this.collectionClone.get(child.get(filterByAttribute));
        var selection = this.collection.findWhere({ selected: true });

        if (selection) {
            selection.set('selected', false, { silent: true });
        }
        parent.set('selected', true);
        //Only top level needs to be re-rendered explicitly, all other levels will be filtered and rendered by parent changed function.
        if (!this.options.parentCollection) {
            this.collection.reset(this.collectionClone.models);
        }
    },
    reset: function (filter) {
        var selection = this.collection.findWhere({ selected: true });
        var parentSelection = this.options.parentCollection.findWhere({ selected: true });
        if (selection && filter.indexOf(selection) < 0) {
            selection.set('selected', false, { silent: true });
        }

        this.collection.reset(filter.length > 0 || parentSelection ? filter : this.collectionClone.models);
    },
    dropdownChanged: function () {
        var value = this.ui.select.val();
        var valueAttribute = this.options.valueAttribute || 'id';
        var filtered = new Backbone.Model();

        this.collection.each(function (model) {
            if (model.get(valueAttribute) == value) {
                model.set('selected', true);
                filtered = model;
            } else if (model.get('selected')) {
                model.set('selected', false, { silent: true });
            }
        });

        this.triggerMethod('dropdownChanged', filtered); // Bubbling events to possible consumers...    
        this.selectionChanged();
    },
    selectionChanged: function () {
        var value = this.ui.select.val();
        var valueAttribute = this.options.valueAttribute || 'id';
        var filtered = new Backbone.Model();

        this.collection.each(function (model) {
            if (model.get(valueAttribute) == value) {
                model.set('selected', true);
                filtered = model;
            } else if (model.get('selected')) {
                model.set('selected', false, { silent: true });
            }
        });

        this.triggerMethod('selectionChanged', filtered); // Bubbling events to possible consumers...        
        this.$('#select').attr('data-tooltip-title', this.$('#select').find(':selected').text()); // Tooltip.
        this.$('#print').text(this.$('#select').find(':selected').text());
        this.options.tooltip ? appendToolTip(this.$('#select')) : "";
    }
});

module.exports.show = function (options) {
    var region = options.region;

    region.show(new View(options));
};


// WEBPACK FOOTER //
// ./js/Modules/UI/Dropdown.js